<div class="product-category-section py-5">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Product <span>Categories</span></h2>
            <div class="title-underline"></div>
            <p class="section-description">Comprehensive educational solutions for modern classrooms</p>
        </div>

        <div class="row g-4">
            <div class="col-12 col-md-6 col-lg-4" *ngFor="let category of productCategories">
                <div class="premium-card h-100" [routerLink]="category.route">
                    <div class="card-glow"></div>
                    <div class="product-image">
                        <img [src]="category.image" [alt]="category.alt || category.title" loading="lazy">
                    </div>
                    <div class="card-content">
                        <h3 class="product-title">{{ category.title }}</h3>
                        <p class="product-description">{{ category.description }}</p>
                        <div class="card-action">
                            <span class="explore-text">Explore</span>
                            <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>